export const reports = {
    route: 'Reports',
    overAll: 'Over All',
    byDevice: 'By Device',
    reportTitle: 'This is the report that we have made with the information collected by your meter for the month of',
    compare: 'Your last month consumption compared to the month before:',
    kwhMissing: 'Please enter your Price per kWh in the app under Account-Settings',
    monthlyConsumption: 'Your monthly consumption (KWh):',
    mostRelevant: 'Most relevant uses:',
    alwaysOn: 'Always ON devices',
    graphTips: 'On this graph, the orange lines show you at which time of the day (x-Axis) and on which day of the month (Y-axis) you have used the device.',
    deviceReport: 'Power usage of your device:',
    savingPotentials: 'Saving Potentials',
    myAvgKwh: 'My device total consumption in past 30 days',
    avgKwh: 'Range for the same device type',
    myAvgW: 'My device wattage',
    avgW: 'Range for the same device type',
    kwhCost: 'cost pro kilowatt',
    wattUnit: 'watt',
    kwUnit: 'kilowatt',
    mwUnit: 'Megawatt',
    kwhUnit: 'kwh',
    kgUnit: 'Kilogram',
    costUnit: '€'
};
